module.exports = require("./socket.js");


//////////////////
// WEBPACK FOOTER
// angular-socket-io (bower component)
// module id = 1037
// module chunks = 1